export const locales = {
    en: {
        'params.title': 'Parameters',
        'params.overhangs': 'Overhangs',
        'params.calculate': 'Get specification',
        'modal.close': 'Close',
        'modal.specification': 'Specification',
        'modal.pcs': 'pcs',
        'units.m': 'm',
        'units.mm': 'mm',
        'units.cm': 'cm',
    },
    ru: {
        'params.title': 'Параметры',
        'params.overhangs': 'Выносы крыши',
        'params.calculate': 'Рассчитать стоимость',
        'modal.close': 'Закрыть',
        'modal.specification': 'Спецификация',
        'modal.pcs': 'шт',
        'units.m': 'м',
        'units.mm': 'мм',
        'units.cm': 'см',
    },
    de: {
        'params.title': 'Parameter',
        'params.overhangs': 'Überstände',
        'params.calculate': 'Preis berechnen',
        'modal.close': 'Schließen',
        'modal.specification': 'Spezifikation',
        'modal.pcs': 'Stk',
        'units.m': 'm',
        'units.mm': 'mm',
        'units.cm': 'cm',
    },
};
export function t(lang, key) {
    return locales[lang]?.[key] ?? locales.en[key] ?? key;
}
